<template>
  <ReportsPage
    :product="product"
    :product-data="productData"
    :forecast-subscription="forecastSubscription"
    :prices-assessment-subscription="subscription"
  >
    <NuxtPage
      :product="product"
      :product-data="productData"
      :forecast-subscription="forecastSubscription"
      :prices-assessment-subscription="subscription"
    />
  </ReportsPage>
</template>

<script setup lang="ts">
import {
  BLACK_MASS,
  MARKET,
  SUBSCRIPTION_FORECASTS_RECYCLING,
  SUBSCRIPTION_PRICE_ASSESSMENTS_BLACK_MASS,
} from '~/constants/services/constants'
import recyclingData from '~/constants/data-reports/recycling'
import ReportsPage from '~/components/market/ReportsPage.vue'
import { capitalize } from '~/utils/string'
import { MARKET_SLUG } from '~/src/constants/markets'

definePageMeta({ layout: 'services' })

const product = ref({
  ...BLACK_MASS,
  title: capitalize(MARKET_SLUG.RECYCLING),
  name: capitalize(MARKET_SLUG.RECYCLING),
})
const productData = ref(recyclingData)
const forecastSubscription = ref(SUBSCRIPTION_FORECASTS_RECYCLING)
const subscription = ref(SUBSCRIPTION_PRICE_ASSESSMENTS_BLACK_MASS)

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${BLACK_MASS.name} Data and Reports`,
})
useHead(seo)
</script>
